import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: 'What are scientific figures?',
          answer:
            "Scientific figures are a creative way to communicate the results of scientific research through a visual resource. It's a manner to present science in an accessible, useful, easy-to-understand style to allow more people to connect with science.",
        },
        {
          question: 'How do you make good scientific figures?',
          answer:
            "To make good scientific figures you'll need to define your goals and audience, set a strong brief, and know what is the main data and what is the most important information that your readers need to understand to create self-explanatory science figures, understandable only by reading, without an extra explanation or content.",
        },
        {
          question: 'What should a good scientific figure include?',
          answer:
            'Good scientific figures include a combination of text, visuals, and design, complementing each other, to improve reading comprehension. Good scientific figures show all relevant information about the research in a clear and visually pleasing way so that the reader can understand it for himself.',
        },
        {
          question: 'Where can I make scientific figures?',
          answer:
            'Mind The Graph is the best free platform for making scientific figures. This way, you ensure that your scientific figures have images with a consistent art style, scientifically accurate illustrations, templates with an intuitive reading flow, graphics, symbols, icons, and appropriate font styles. You can also publish your scientific figures designed with Mind The Graph in journals, magazines, blogs, social media, books, and more!',
        },
      ]}
    />
  );
}
